module.exports = __webpack_public_path__ + "static/media/img-estratto-conto-home.a169d494.png";